import { type FC, useEffect } from 'react';
import {
  StyledHeading1,
  StyledParagraph,
} from '../Typography/typography.styles';
import reactLogo from '../../assets/not-found.svg';
import { StyledContainer, StyledImage } from './error-boundary.styles';
import { useRouteError } from 'react-router';
import * as Sentry from '@sentry/react';

export const ErrorBoundary: FC = () => {
  const error = useRouteError() as Error;

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <StyledContainer>
      <div>
        <StyledHeading1>Coś poszło nie tak!</StyledHeading1>
        <StyledParagraph>
          Coś poszło nie tak. Spróbuj ponownie później.
        </StyledParagraph>
      </div>
      <StyledImage alt="Busem w Trasę - Strona nie istnieje" src={reactLogo} />
    </StyledContainer>
  );
};
